// frontend/src/services/http.ts
import axios, { AxiosInstance, AxiosRequestConfig, AxiosError } from 'axios';

const isBrowser = typeof window !== 'undefined';

// ظبط التوجيه اثناء إتمام الدفع
const resolvedBaseURL =
  process.env.NODE_ENV === 'production'
    ? 'https://api.badanibex.com'
    : (process.env.REACT_APP_API_BASE_URL || '');

const http: AxiosInstance = axios.create({
  baseURL: resolvedBaseURL,
  withCredentials: true,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
});

// إرفاق Session السلة
http.interceptors.request.use((config) => {
  if (isBrowser) {
    const sid = localStorage.getItem('cart_session');
    if (sid) {
      config.headers = config.headers ?? {};
      (config.headers as Record<string, string>)['X-Cart-Session'] = sid;
    }
  }
  return config;
});

// إعادة المحاولة بعد 401 (مرّة واحدة)، باستثناء csrf-cookie نفسه
let isRefreshing = false;
let pendingQueue: Array<() => void> = [];

type RetryConfig = (AxiosRequestConfig & { _retried?: boolean }) | undefined;

http.interceptors.response.use(
  (res) => res,
  async (error: AxiosError) => {
    const original = error.config as RetryConfig;

    // لا نعيد المحاولة لطلب csrf نفسه
    if (original?.url?.includes('/sanctum/csrf-cookie')) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && original && !original._retried) {
      original._retried = true;

      if (isRefreshing) {
        await new Promise<void>((resolve) => pendingQueue.push(resolve));
      } else {
        isRefreshing = true;
        try {
          await ensureCsrfCookie();
        } finally {
          isRefreshing = false;
          pendingQueue.forEach((fn) => fn());
          pendingQueue = [];
        }
      }
      return http(original);
    }

    return Promise.reject(error);
  }
);

// CSRF bootstrap
// let csrfFetched = false;
// export async function ensureCsrfCookie(): Promise<void> {
//   if (!isBrowser) return;
//   if (csrfFetched) return;
//   try {
//     await http.get('/sanctum/csrf-cookie');
//     csrfFetched = true;
//   } catch {
//     await new Promise((r) => setTimeout(r, 200));
//     await http.get('/sanctum/csrf-cookie');
//     csrfFetched = true;
//   }
// }

// export function resetCsrfFlag() {
//   csrfFetched = false;
// }


function readCookie(name: string): string | null {
  if (!isBrowser) return null
  const match = document.cookie.split(';').find(c => c.trim().startsWith(name + '='))
  return match ? decodeURIComponent(match.trim().split('=').slice(1).join('=')) : null
}

let csrfFetched = false

export async function ensureCsrfCookie(): Promise<void> {
  if (!isBrowser) return
  if (csrfFetched) return
  try {
    await http.get('/sanctum/csrf-cookie')
    csrfFetched = true
  } catch (e) {
    await new Promise(res => setTimeout(res, 200))
    await http.get('/sanctum/csrf-cookie')
    csrfFetched = true
  }
  // قراءة الـ token يدوياً وضبطه كـ header ثابت (يحل مشكلة cross-subdomain)
  const token = readCookie('XSRF-TOKEN')
  if (token) {
    http.defaults.headers.common['X-XSRF-TOKEN'] = token
  }
}

export function resetCsrf(): void {
  csrfFetched = false
  delete http.defaults.headers.common['X-XSRF-TOKEN']
}

export default http;
export { /* ensureCsrfCookie etc if defined elsewhere */ };
